function discountMetaSideMatches(metaItem, side, productId, variantId) {
  const matcher = window.theme?.discountMeta?.sideMatches;
  if (typeof matcher === 'function') {
    return matcher(metaItem, side, productId, variantId);
  }
  const products = metaItem?.[`products_${side}`];
  return Array.isArray(products) && products.some((product) => product.id == productId);
}

function discountMetaApplyBuy1Off(price, metaItem) {
  const apply = window.theme?.discountMeta?.applyBuy1Off;
  if (typeof apply === 'function') {
    return apply(price, metaItem);
  }
  const off = Number(metaItem?.off) || 0;
  return (Number(price) || 0) * (1 - off);
}

function discountMetaAmountOffPairs(metaItem, productIdA, productIdB) {
  const listHas = (list, productId) =>
    Array.isArray(list) && list.some((product) => product.id == productId);
  return (
    (listHas(metaItem?.products_1, productIdA) && listHas(metaItem?.products_2, productIdB)) ||
    (listHas(metaItem?.products_1, productIdB) && listHas(metaItem?.products_2, productIdA))
  );
}

if (!customElements.get('product-bundle')) {
  class ProductBundle extends HTMLElement {
    /**
     * Section settings
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    constructor() {
      super();
    }

    init() {
      this.autoSelectOption = this.getAttribute("data-auto-select-option") == "true";
      window.addEventListener("DOMContentLoaded", () => {
        setTimeout(() => {
          this.selectSameOption(document.querySelector("radio-swatch input:checked+label"));
        }, 1);
      });
      if (this.autoSelectOption) {
        $("radio-swatch label").on("click", (e) => {
          const el = e.target;
          this.selectSameOption(el);
        });
      }
      document.addEventListener('theme:variant:change', (event) => this.updateItemsPrice());
      this.initOnlySwiper(0);
      this.addEventListener("click", (e) => {
        // Tab 大标题点击事件
        if (e.target?.matches(".product-bundle__tabs li")) {
          const tabIndex = e.target.getAttribute("data-index");
          // 已经在该标签下了，不执行任何操作
          if (e.target.classList.contains("active")) return;
          // 移除 active
          this.querySelector(".product-bundle__tabs li.active")?.classList.remove("active");
          this.querySelector(".swiper.active")?.classList.remove("active");
          // 添加 active
          this.querySelector(`.swiper[data-index="${tabIndex}"]`).classList.add("active");
          e.target.classList.add("active");
          // 重建 Swiper
          this.initOnlySwiper(tabIndex);
        }
      });
    }

    /** bundle 产品跟随主产品的相同名称选项，自动切换到一样的选项 */
    selectSameOption(labelElement) {
      const value = labelElement.getAttribute("data-swatch");
      const bundleItems = this.querySelectorAll("product-bundle-item");
      for (const bundle of bundleItems) {
        const select = bundle.querySelector("select");
        const options = select.querySelectorAll("option");
        for (const option of options) {
          const optionValueList = option.innerText.trim().split('/');
          const findValue = optionValueList.find((v) => v.trim() == value.trim());
          if (findValue) {
            $(select).val(option.value);
            bundle.changeVariantIfAvailable(option.value);
          }
        }
      }
    }

    /**
     * 初始化指定 Tab 下的 Swiper，销毁其他 Tab 下的 Swiper
     * 
     * @param {*} tabIndex Tab的索引
     */
    initOnlySwiper(tabIndex) {
      this.mySwiper?.destroy();
      const containerSelector = `.swiper[data-index="${tabIndex}"]`;
      this.mySwiper = new Swiper(this.querySelector(`${containerSelector}`), {
        loop: false,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: this.querySelector(`.swiper-btn-next`),
          prevEl: this.querySelector(`.swiper-btn-prev`),
        },
        // pagination: {
        //   el: this.querySelector('.swiper-pagination'),
        //   clickable: true,
        // },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          750: {
            spaceBetween: 12,
          }
        },
      });
    }

    /** 更新所有子项的价格 */
    updateItemsPrice() {
      for (const item of this.querySelectorAll("product-bundle-item")) {
        item.updatePrice();
      }
    }

    connectedCallback() {
      this.observeElement(this, this.handleInViewport.bind(this));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    handleInViewport() {
      // 初始化元素
      this.init();
    }

    observeElement(element, callback) {
      // 创建一个 IntersectionObserver 实例
      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            callback();
            // 只执行一次，停止观察
            observerInstance.unobserve(entry.target);
          }
        });
      }, {
        // 视口外 1/2 高度以内触发
        root: null,
        threshold: 0.5
      });
      // 如果已经在视口内,立即执行回调
      if (this.isElementInViewport(element)) {
        callback();
        return;
      }
      observer.observe(element);
      this.observer = observer;
    }

    // 判断元素是否在视口内
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0;
    }
  }

  customElements.define('product-bundle', ProductBundle);
}

if (!customElements.get('product-bundle-item')) {
  class ProductBundleItem extends HTMLElement {
    constructor() {
      super();
      this.product = JSON.parse(this.getAttribute("data-product-json").replaceAll("/'", '"'));
      this.variant = this.product.variants.find((v) => v.available) ?? this.product.variants[0];
      this.productImage = this.querySelector("[data-product-image]");
      this.price = this.querySelector("[data-price]");
      this.comparePrice = this.querySelector("[data-compare-price]");
      this.select = this.querySelector("select");
      this.selectLabel = this.querySelector("[data-select-label]");
      this.addCartButton = this.querySelector("[data-add-cart-button]");
      this.bundlePriceLabel = this.querySelector("[data-bundle-price]");
      this.bundleComparePriceLabel = this.querySelector("[data-bundle-compare-price]");

      this.showDialogButtons = this.querySelectorAll("[data-show-dialog-button]");
      this.bundleId = `product-bundle-item__${new Date().getTime()}`;
      this.setAttribute("data-id", this.bundleId);

      this.outerWrapper = this.closest("[data-section-id]");
      this.outerProductJSON = JSON.parse(this.outerWrapper.querySelector("[data-product-json]").innerHTML);
      this.outerVariantInput = this.outerWrapper.querySelector(`[data-product-form-outer] input[name="id"]`);
      this.outerQuantity = this.outerWrapper.querySelector("[data-quantity-input]");
      this.updatePrice();

      this.drawer = document.querySelector("[data-drawer='drawer-cart']");
      this.initEvent();
    }

    initEvent() {
      this.select.addEventListener("change", (e) => {
        this.changeVariant(e.target.value);
      });
      this.addCartButton.addEventListener("click", (e) => {
        e.target.classList.add("loading");
        const mainVariantId = this.getParameterFromUrl("variant", window.location.href) ?? JSON.parse(document.querySelector("[data-product-json]").innerText).variants[0].id;
        this.addToCart([{ id: mainVariantId, quantity: 1 }, { id: this.select.value, quantity: 1 }]).then(async () => {
          e.target.classList.remove("loading");
          const cart = await fetch(`${window.theme.routes.cart}.js`).then((r) => r.json());
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              detail: { cart },
              bubbles: true,
            })
          );
          if (this.drawer) {
            this.drawer.dispatchEvent(
              new CustomEvent('theme:drawer:toggle', {
                bubbles: false,
              })
            );
          }
          monster_refresh(true);
        });
      });
      this.outerQuantity.addEventListener("change", (e) => {
        // const quantity = Number(e.target.value);
        this.updatePrice();
      });
      for (const el of this.showDialogButtons) {
        el.addEventListener("click", () => this.showDialog());
      }
    }

    showDialog() {
      window.theme.dialogs?.openQuickview(this.product.handle);
    }

    updatePrice(outerQuantity = 1) {
      const outerVariant = this.outerProductJSON.variants.find((v) => v.id == this.outerVariantInput.value);
      const outerPrice = outerVariant.price;
      const outerComparePrice = outerVariant.compare_at_price;
      const price = this.variant.price;
      const comparePrice = this.variant.compare_at_price;
      let bothPrice = (outerPrice + price) * outerQuantity;
      let bothComparePrice = ((outerPrice < outerComparePrice ? outerComparePrice : outerPrice) + (price < comparePrice ? comparePrice : price)) * outerQuantity;
      const comboBase = (outerPrice + price) * outerQuantity;
      const priceList = [];
      if (window.theme.discountMeta?.buy_1_get_1_off?.length) {
        for (const metaItem of window.theme.discountMeta.buy_1_get_1_off) {
          if (
            discountMetaSideMatches(metaItem, 1, this.outerProductJSON.id, outerVariant.id) &&
            discountMetaSideMatches(metaItem, 2, this.product.id, this.variant.id)
          ) {
            priceList.push(Math.ceil((outerPrice + discountMetaApplyBuy1Off(price, metaItem)) * outerQuantity));
          }
        }
      }
      if (window.theme.discountMeta?.amount_off_products_bundle?.length) {
        for (const metaItem of window.theme.discountMeta.amount_off_products_bundle) {
          if (discountMetaAmountOffPairs(metaItem, this.outerProductJSON.id, this.product.id)) {
            priceList.push(Math.ceil(comboBase * (1 - (Number(metaItem.off) || 0))));
          }
        }
      }
      if (priceList.length > 0) {
        bothPrice = Math.min(...priceList);
      }
      this.bundlePriceLabel.innerHTML = this.formattingMoney(bothPrice);
      this.bundleComparePriceLabel.innerHTML = bothPrice < bothComparePrice ? this.formattingMoney(bothComparePrice) : '';
    }

    formattingMoney(money) {
      if (theme.settings.currency_code_enable) {
        return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat) + ` ${theme.currencyCode}`;
      } else {
        return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat);
      }
    }

    // 切换变体, 但只有变体未售罄才会切换
    changeVariantIfAvailable(variantId) {
      const variant = this.product.variants.find(v => v.id == variantId) ?? this.product.variants[0];
      if (variant && variant.available) {
        this.changeVariant(variantId);
      }
    }

    changeVariant(variantId) {
      this.selectLabel.innerText = this.select.selectedOptions[0].innerText.trim();
      const variant = this.product.variants.find(v => v.id == variantId) ?? this.product.variants[0];
      this.variant = variant;
      if (!variant) {
        console.error(`variant for id: ${variantId} not found.`);
        return;
      }
      let src = variant.featured_image.src ?? this.product.featured_image;
      src.includes('?') ? src += "&width=200" : src += "?width=200";
      this.productImage.src = src;
      this.price.innerHTML = themeVendor.themeCurrency.formatMoney(variant.price, theme.moneyFormat);
      if (variant.price < variant.compare_at_price) {
        this.comparePrice.innerHTML = themeVendor.themeCurrency.formatMoney(variant.compare_at_price, theme.moneyFormat);
      } else {
        this.comparePrice.innerHTML = "";
      }
      if (variant.available) {
        this.addCartButton.removeAttribute("disabled");
      } else {
        this.addCartButton.setAttribute("disabled", "");
      }
      this.updatePrice();
    }

    /**
     * 加购
     * @param {[{id: string, quantity: number}]} items 
     */
    async addToCart(items) {
      let formData = {
        'items': items
      };
      return fetch(window.Shopify.routes.root + "cart/add.js",
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData),
        }
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
      }).catch((err) => {
        console.error(err);
      });
    }

    getParameterFromUrl(name, url) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
  }

  customElements.define('product-bundle-item', ProductBundleItem);
}
